import classNames from 'classnames';

import React, { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';

import Loader from '../Loader/Loader';

import styles from './styles.module.scss';

interface IButtonProps {
  children?: React.ReactNode,
  className?: string,
  transparent?: boolean,
  fullWidth?: boolean,
  variant?: 'primary' | 'secondary' | 'error' | 'success' | 'disabled',
  small?: boolean,
  large?: boolean,
  quad?: boolean,
  outlined?: boolean,
  loading?: boolean,
  onClick?: (e: React.MouseEvent) => void,
  keyDown?: (e: React.KeyboardEvent<HTMLButtonElement>) => void,
  type?: 'submit' | 'reset' | 'button',
  icon?: React.ReactNode,
  lngKey?: string,
  disabled?: boolean,
}

const Button = forwardRef<HTMLButtonElement, IButtonProps>(({
  children,
  className,
  transparent,
  fullWidth,
  small,
  large,
  quad,
  outlined,
  loading,
  variant = 'primary',
  onClick,
  keyDown,
  type = 'button',
  icon,
  lngKey = '',
  disabled,
}, ref) => {
  const { t } = useTranslation();

  const tp = transparent ? styles.transparent : '';
  const fw = fullWidth ? styles.fullWidth : '';
  const sm = small ? styles.small : '';
  const lg = large ? styles.large : '';
  const qd = quad ? styles.quad : '';
  const ol = outlined ? styles.outlined : '';
  // @ts-ignore
  const color = styles[variant];

  const cn = classNames(styles.button, tp, fw, sm, lg, qd, ol, color, className);

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    const noClick = variant === 'disabled' || loading;
    if (noClick) {
      e.preventDefault();
    } else if (onClick) {
      onClick(e);
    }
  };
  return (
    <button
      type={type}
      className={cn}
      onClick={handleClick}
      onKeyDown={keyDown}
      ref={ref}
      disabled={disabled}
    >
      {loading
        ? <Loader className={styles.buttonLoader} />
        : (
          <>
            {children || t(lngKey)}
            {icon}
          </>
        )}
    </button>
  );
});

export default Button;
